import { GLOBAL_LOADING_INCREMENT, GLOBAL_LOADING_DECREMENT } from './consts'

export const incrementGlobalLoading = () => ({ type: GLOBAL_LOADING_INCREMENT })
export const decrementGlobalLoading = () => ({ type: GLOBAL_LOADING_DECREMENT })
